import { HTMLProps, ReactNode } from 'react';
import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { isPC } from 'constants/layout';
import { Button } from 'ui-components/common/Button';
import { BottomButtonHeight, ButtonSize, MobileBottomButtonHeight } from 'constants/button';

type Modify<T, R> = Omit<T, keyof R> & R;

export type BottomButtonProps = Modify<
  HTMLProps<HTMLButtonElement>,
  {
    className?: string;
    label: string | ReactNode;
    type?: 'button' | 'submit' | 'reset';
    size?: ButtonSize;
    disabled?: boolean;
    onClick: () => void;
  }
>;

export const BottomButton = ({ type = 'button', className, label, onClick, disabled, ...props }: BottomButtonProps) => (
  <StyledBottomButton className={className}>
    <Button type={type} label={label} onClick={onClick} disabled={disabled} fullWidth {...props} />
  </StyledBottomButton>
);

const StyledBottomButton = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${MobileBottomButtonHeight}px;
  bottom: 0;
  padding: 16px 16px 8px 16px;
  background: ${Color.White};
  border-top: 1px solid ${Color.Gray300};
  flex-shrink: 0;

  @media (${isPC}) {
    position: fixed;
    width: 100%;
    height: ${BottomButtonHeight}px;
    max-width: 730px;
    padding: 16px;
  }
`;
